"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectedOptionFacade = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _menuTheme = require("../../../menu/styled/menuTheme");
var _typography = require("../../../typography");
const SelectedOptionFacade = (0, _styled.default)(_typography.TypeRampV2)`
    font-size: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _menuTheme.menuTheme.fontSize(themeMode);
}};
    line-height: 18px;
    min-width: 0;
    overflow-wrap: break-word;
`;
exports.SelectedOptionFacade = SelectedOptionFacade;
//# sourceMappingURL=SelectedOptionFacade.js.map